export default __webpack_public_path__ + "static/media/img_failed.57c530ea.png";